import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var container = 'fx_2d2fb1e5_zg44saa';
var subtext = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_zg44sa7',variantClassNames:{size:{'default':'fx_2d2fb1e5_zg44sa8',large:'fx_2d2fb1e5_zg44sa9'}},defaultVariants:{size:'default'},compoundVariants:[]});
var title = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_zg44sa4',variantClassNames:{size:{'default':'fx_2d2fb1e5_zg44sa5',large:'fx_2d2fb1e5_zg44sa6'}},defaultVariants:{size:'default'},compoundVariants:[]});
var topSlotRoot = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_zg44sa1',variantClassNames:{size:{'default':'fx_2d2fb1e5_zg44sa2',large:'fx_2d2fb1e5_zg44sa3'}},defaultVariants:{size:'default'},compoundVariants:[]});

export { container, subtext, title, topSlotRoot };
//# sourceMappingURL=empty.vanilla.mjs.map
